import { Component, inject, OnInit } from '@angular/core';
import { IPost } from 'src/app/services/posts/post.interface';
import { BlogService } from 'src/app/services/posts/posts-v2.service';
import { APOLLO_FETCH_ERROR } from '../../shared/constants/error.constants';

@Component({
    selector: 'app-whats-new',
    templateUrl: './whats-new.page.html',
    styleUrls: ['./whats-new.page.scss'],
    standalone: false,
})
export class WhatsNewPage implements OnInit {
    public loading = true;
    public error: string | null = null;
    public posts: IPost[] = [];
    public headerImage = 'assets/images/Whats-New-128x82-v2.png';

    private readonly blogService = inject(BlogService);

    ngOnInit(): void {
        this.blogService.getPosts$("What's New").subscribe({
            next: (posts: IPost[]) => {
                this.loading = false;
                this.posts = posts;
            },
            error: (err: any) => {
                this.loading = false;
                console.error('Error fetching posts:', err);
                this.error = APOLLO_FETCH_ERROR;
            },
        });
    }
}
